import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { StageButton } from '../../../../../../theme/projects/Buttons/stageButton';
import { CheckCircle, CircleOutlined, Store } from '@mui/icons-material';
import { TableProjectTask } from '../ProjectTask/table';
import { ProjectStage } from '../../../../../../interfaces/Projects/Catalogs/projectStages';
import GenericPromises from '../../../../../../api/GenericPromises';
import useSnackBar from '../../../../../../components/Commons/SnackBar/useSnackBar';
import { useTranslation } from 'react-i18next';
import { DialogEntity } from '../../../../../../components/Dialogs/DialogEntity';
import { Header } from '../../../../../../components/Header';
import { ConfirmChangeProjectStageStatusDialog } from './dialogs/confirmChangeProjectStageStatusDialog';
import { ProjectTask } from '../../../../../../interfaces/Projects/Catalogs/projectTasks';
import { FieldType } from '../../../../../../interfaces/Projects/Catalogs/fieldTypes';
import { UpdateProjectStages } from '../ProjectStages/update';
import { Menuitem } from '../../../../../../interfaces/Security/menu';
import { useProjectTasksStore } from '../../../../../../store/Projects/ProjectDetails/ProjectTasksStore';
import { useProjectStagesStore } from '../../../../../../store/Projects/ProjectDetails/ProjectStagesStore';

interface StageItemProps {
  isEdit: boolean,
  stage: ProjectStage;
  color: number[] | undefined;
  comboFieldTypes: FieldType[];
  resourceScreen: Menuitem
}

export const StageItem = ({
  isEdit,
  stage,
  color,
  comboFieldTypes,
  resourceScreen
}: StageItemProps) => {

  const {
    GenericPutResource,
  } = GenericPromises();
  const [loadingPut, setLoadingPut] = useState(false);
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const [t] = useTranslation("global");
  const [dialogConfirmChangeStageState, setDialogConfirmChangeStageState] = useState(false);
  const [openDialogUpdateStage, setOpenDialogUpdateStage] = useState(false);
  const updateTaskInStage = useProjectTasksStore(store => store.updateTaskInStage);
  const setIsStageCompleted = useProjectStagesStore(store => store.setIsStageCompleted)

  const storeChecked = useProjectStagesStore(store => {
    if (stage.project_stage_id) {
      return store.isStageCompleted[stage.project_stage_id] ?? false
    }
  });

  const handleStageCompletion = () => {
    setLoadingPut(true);
    let myData = {
      is_done: !storeChecked
    };
    GenericPutResource(
      `/projectstages/isdone/${stage.project_stage_id}`,
      myData
    )
      .then((response) => {
        response.data.forEach((task: ProjectTask) => {
          if (stage.project_stage_id) {
            updateTaskInStage(stage.project_stage_id, task)
          }
        })
        if (stage.project_stage_id) {
          setIsStageCompleted(stage.project_stage_id, !storeChecked)
        }
        showSnackBar(t("projectstages.messages.state_updated"), "success");
      })
      .catch((error) => {
        if (error.response.data.message) {
          showSnackBar(t(error.response.data.message), "info");
        } else {
          showSnackBar(error.message, "error");
        }
      })
      .finally(() => {
        setLoadingPut(false);
        setDialogConfirmChangeStageState(false);
      });
  }

  return (
    <>
      <Grid
        item
        key={stage.project_stage_id}
        xs={8}
        md={5}
        style={{ flexShrink: 0 }}
      >
        <StageButton
          color={color}
          onClick={() => {
            setOpenDialogUpdateStage(true);
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={storeChecked}
                onChange={(e) => {
                  e.stopPropagation();
                  setOpenDialogUpdateStage(false);
                  setDialogConfirmChangeStageState(true)
                }}
                icon={<CircleOutlined />}
                checkedIcon={<CheckCircle />}
                sx={{
                  color: "primary.main",
                  "&:hover": {
                    color: "primary.main",
                  },
                  "&.Mui-checked": {
                    color: "#ffffff",
                  },
                }}
              />
            }
            label={<></>}
            disabled={loadingPut}
          />
          {stage.project_stage_name}
        </StageButton>
        <TableProjectTask
          project_stage_id={stage.project_stage_id}
          project_id={stage.project_id}
          isDoneProjectStage={storeChecked || false}
          setDialogConfirmChangeStageState={setDialogConfirmChangeStageState}
          comboFieldTypes={comboFieldTypes}
        />
      </Grid>
      <DialogEntity
        open={dialogConfirmChangeStageState}
        title={<Header title={t("projectstages.title-view")} />}
        maxWidth={"sm"}
        fullWidth
        content={
          <ConfirmChangeProjectStageStatusDialog
            isEdit={isEdit}
            loadingPut={loadingPut}
            setDialogConfirmChangeStageState={setDialogConfirmChangeStageState}
            handleStageCompletion={handleStageCompletion}
            stageName={stage.project_stage_name}
          />
        }
      />
      <DialogEntity
        content={
          <UpdateProjectStages
            permissions={resourceScreen}
            setOpenDialog={setOpenDialogUpdateStage}
            projectStagePayload={stage}
            comboFieldTypes={comboFieldTypes}
          />
        }
        open={openDialogUpdateStage}
        setOpen={setOpenDialogUpdateStage}
        title={<Header title={t("projectstages.title-view")} size="sm" />}
      />
      <SnackbarComponent />
    </>
  )
}
